module.exports =
  print:
    raw:
      base: '/printer/raw'
      bulk: '/printer/raw/bulk'
    template:
      base: '/printer/template'
      bulk: '/printer/template/bulk'
    url:
      base: '/printer/url'
      bulk: '/printer/url/bulk'
  types: '/printer/types'
  updater:
    update: '/printer/updater/update'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/printer.coffee